import React, { useEffect } from "react";
import TaskFormData from "./components/TaskFormData";
import TaskTableData from "./components/TaskTableData";
import { useDispatch } from "react-redux";
import { fetchStaffs } from "../../../store/features/user/userSlice";
import { fetchTasks } from "../../../store/features/task/taskSlice";

const Tasks = ({
  setTaskInfo,
  taskInfo,
  wpInfo,
  role,
  setWpInfo,
  setShowTaskModal,
  showTaskModal,
  deliverablesInfo,
  setDeliverablesInfo
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchStaffs());
    dispatch(fetchTasks());
  }, [dispatch]);

  return (
    <div>
      {role !== "auditor" && (
        <TaskFormData
          setWpInfo={setWpInfo}
          setTaskInfo={setTaskInfo}
          wpInfo={wpInfo}
          taskInfo={taskInfo}
          setShowTaskModal={setShowTaskModal}
          showTaskModal={showTaskModal}
        />
      )}

      <TaskTableData
        setTaskInfo={setTaskInfo}
        wpInfo={wpInfo}
        setWpInfo={setWpInfo}
        deliverablesInfo={deliverablesInfo}
        setShowTaskModal={setShowTaskModal}
        setDeliverablesInfo={setDeliverablesInfo}
      />
    </div>
  );
};

export default Tasks;
